export const isNumberKey = (event: KeyboardEvent) => {
  if (['Tab', 'Backspace', 'Delete'].includes(event.key) || event.key?.startsWith('Arrow')) {
    return true
  }
  const pattern = /^[0-9]+$/
  if (!pattern.test(event.key)) {
    event.preventDefault()
  }
}

export const isAlphabeticalKey = (event: KeyboardEvent) => {
  if (['Tab', 'Backspace', 'Delete'].includes(event.key) || event.key?.startsWith('Arrow')) {
    return true
  }
  const pattern = /^[a-zA-ZáÁéÉíÍóÓúÚäÄëËïÏöÖüÜñÑçÇ\s-]+$/
  if (!pattern.test(event.key)) {
    event.preventDefault()
  }
}

export const blockCharacters = (event: KeyboardEvent, regexString: RegExp) => {
  const pattern = new RegExp(regexString)
  if (pattern.test(event.key)) {
    event.preventDefault()
  }
}

export const acceptCharacters = (event: KeyboardEvent, regexString: RegExp) => {
  const pattern = new RegExp(regexString)
  if (!pattern.test(event.key)) {
    event.preventDefault()
  }
}
